import { createFileRoute } from '@tanstack/react-router'
import WorkRoyalty from 'Work/components/Work/Sections/Royalty/WorkRoyalty'

import { Guard } from '../../-guard'

export const Route = createFileRoute('/work/$workId/royalty')({
    component: () => (
        <Guard notFeatures={['profitability']}>
            <WorkRoyalty />
        </Guard>
    ),
})
